import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

export const LeaderboardScores = styled.ul`
  list-style: none;
  padding: 0px;
  margin: 0px;
`;

const LIST_WIDTH = 80;

type ScoreContainerAttributes = {
  $user?: boolean;
};

export const ScoreContainer = styled.li<ScoreContainerAttributes>(
  ({ $user }) => css`
    border-bottom: 1px solid #e5e5e5;
    padding-inline: 12px;
    margin-bottom: 12px;

    position: relative;
    line-height: 28px;
    overflow: hidden;

    height: 28px;
    width: 100%;

    &:nth-child(-n + 3) {
      > div:last-child {
        justify-content: flex-start;
        column-gap: 6px;

        > em:last-child {
          margin-left: auto;
        }
      }
    }

    ${$user &&
    css`
      &:last-child {
        background-color: ${Theme.color.orange};
        border-radius: 50px;
        padding-block: 12px;

        margin-bottom: 0px;
        line-height: 20px;
        height: 40px;

        > div > span:first-child {
          font-weight: ${Theme.font.weight.bold};
        }
      }
    `}
  `
);

export const LeaderboardTitle = styled.h2`
  line-height: ${Theme.rems(28.8)};
  font-size: ${Theme.rems(24)};

  margin-bottom: 15px;
  text-align: center;
  letter-spacing: 0;
`;

export const LeaderboardDescription = styled.p`
  margin-block: 12px 22px;
  text-align: center;
`;

export const UserPosition = styled.pre`
  font-weight: ${Theme.font.weight.bold};
  line-height: ${Theme.rems(16)};
  width: ${100 - LIST_WIDTH}%;

  display: inline-block;
  font-family: inherit;
  letter-spacing: 0px;

  text-align: left;
  margin: 0px;
`;

export const UserScoreList = styled.div`
  justify-content: space-between;
  width: ${LIST_WIDTH}%;
  display: inline-flex;

  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;

  > span:first-child {
    line-height: ${Theme.rems(16)};
    font-size: ${Theme.rems(16)};

    text-overflow: ellipsis;
    white-space: nowrap;
    letter-spacing: 0;
    overflow: hidden;
  }

  > svg:nth-child(2) {
    transform: translateY(-2px);
    aspect-ratio: 1 / 1;
    height: 22px;
  }
`;

export const UserScore = styled.em`
  font-style: ${Theme.font.style.normal};
  line-height: ${Theme.rems(16)};
  font-size: ${Theme.rems(16)};

  letter-spacing: 0px;
  font-weight: 900;
`;
